import React, { useEffect, useState } from 'react';
import { drawdownAPI } from '../../services/api';
import { ChevronDown, ChevronUp, Copy } from 'lucide-react';

/**
 * Collapsible reference panel listing every supported `{{placeholder}}` for
 * the Receipt Remarks Template input. Click a row to copy the token.
 * Used on Drawdown create + edit forms.
 */
const ReceiptRemarksHint = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState('');

  useEffect(() => {
    drawdownAPI.getRemarksPlaceholders()
      .then(r => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  const handleCopy = (key) => {
    const token = `{{${key}}}`;
    navigator.clipboard?.writeText(token);
    setCopied(key);
    setTimeout(() => setCopied(''), 1200);
  };

  return (
    <div className="mt-2 border border-gray-200 rounded-lg overflow-hidden" data-testid="receipt-remarks-hint">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-3 py-2 bg-gray-50 hover:bg-gray-100 text-xs text-gray-700"
        data-testid="receipt-remarks-hint-toggle">
        <span>
          <strong>{items.length}</strong> available placeholders — click to expand
        </span>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>
      {open && (
        <div className="max-h-56 overflow-y-auto bg-white">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50">
              <tr className="text-left text-gray-500">
                <th className="px-3 py-1.5 font-medium">Placeholder</th>
                <th className="px-3 py-1.5 font-medium">Description</th>
                <th className="px-3 py-1.5 font-medium">Example</th>
                <th className="w-8"></th>
              </tr>
            </thead>
            <tbody>
              {items.map(p => (
                <tr key={p.key} className="border-t hover:bg-gray-50">
                  <td className="px-3 py-1.5 font-mono text-blue-700">{`{{${p.key}}}`}</td>
                  <td className="px-3 py-1.5 text-gray-700">{p.label}</td>
                  <td className="px-3 py-1.5 text-gray-500 truncate max-w-[180px]">{p.example}</td>
                  <td className="px-2">
                    <button type="button" onClick={() => handleCopy(p.key)}
                      className="p-1 text-gray-400 hover:text-blue-600"
                      title="Copy placeholder">
                      <Copy size={12} />
                    </button>
                    {copied === p.key && (
                      <span className="text-[10px] text-green-600 ml-1">copied</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ReceiptRemarksHint;
